import { render, staticRenderFns } from "./ApproveUser.vue?vue&type=template&id=a36dba74&scoped=true&"
import script from "./ApproveUser.vue?vue&type=script&lang=js&"
export * from "./ApproveUser.vue?vue&type=script&lang=js&"
import style0 from "./ApproveUser.vue?vue&type=style&index=0&id=a36dba74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36dba74",
  null
  
)

export default component.exports